import { ApiTypes, StateRecord } from '@mode/shared/contract-common';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace OrganizationFeatures {
  export enum Type {
    LimitedMemberships = 'limited_memberships',
    DirectoryIntegration = 'directory_integration',
    SecretEmbeds = 'secret_embeds',
    SignedEmbeds = 'signed_embeds',
    ExternalSharing = 'external_sharing',
    PrependScript = 'prepend_script',
    OrgStats = 'org_stats',
    DataSourceRestricted = 'data_source_restricted',
    SpaceRestricted = 'space_restricted',
    IdentityControl = 'identity_control',
    CustomReportThemes = 'custom_report_themes',
    ReportExploration = 'report_exploration',
    ScimProvisioning = 'scim_provisioning',
    BatchReportStats = 'batch_report_stats',
  }

  export enum Context {
    User = '[OrganizationFeatures] User',
    Report = '[OrganizationFeatures] Report',
  }
}

export interface OrganizationFeatureResource extends StateRecord, ApiTypes.ModeResource {
  [OrganizationFeatures.Type.LimitedMemberships]: boolean;
  [OrganizationFeatures.Type.DirectoryIntegration]: boolean;
  [OrganizationFeatures.Type.SecretEmbeds]: boolean;
  [OrganizationFeatures.Type.SignedEmbeds]: boolean;
  [OrganizationFeatures.Type.ExternalSharing]: boolean;
  [OrganizationFeatures.Type.PrependScript]: boolean;
  [OrganizationFeatures.Type.OrgStats]: boolean;
  [OrganizationFeatures.Type.DataSourceRestricted]: boolean;
  [OrganizationFeatures.Type.SpaceRestricted]: boolean;
  [OrganizationFeatures.Type.IdentityControl]: boolean;
  [OrganizationFeatures.Type.CustomReportThemes]: boolean;
  [OrganizationFeatures.Type.ReportExploration]: boolean;
  [OrganizationFeatures.Type.ScimProvisioning]: boolean;
  [OrganizationFeatures.Type.BatchReportStats]: boolean;
}
